/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Sweetnya API
 * 스윗냐 서버 API 문서
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminChangeFirstPasswordDto,
  AdminChangePasswordDto,
  AdminChangePasswordResponseDto,
  AdminFindEmailDto,
  AdminFindEmailResponseDto,
  AdminIssueTempPasswordDto,
  AdminIssueTempPasswordResponseDto,
  AdminLoginResponseDto,
  AdminMeResponseDto,
  AdminProfileResponseDto,
  AdminRequestCodeDto,
  AdminRequestCodeResponseDto,
  AdminVerifyCodeDto,
  UpdateAdminProfileDto
} from '../model';

import { axiosInstance } from '../../axiosInstance.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary 관리자 로그인 요청 및 인증코드 발송
 */
export const adminAuthControllerLogin = (
    adminRequestCodeDto: AdminRequestCodeDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminRequestCodeResponseDto>(
      {url: `/api/v1/admin/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminRequestCodeDto, signal
    },
      );
    }




export const getAdminAuthControllerLoginQueryKey = (adminRequestCodeDto?: AdminRequestCodeDto,) => {
    return [
    'POST', `/api/v1/admin/auth/login`, adminRequestCodeDto
    ] as const;
    }


export const getAdminAuthControllerLoginQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError = unknown>(adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerLoginQueryKey(adminRequestCodeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerLogin>>> = ({ signal }) => adminAuthControllerLogin(adminRequestCodeDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerLoginQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerLogin>>>
export type AdminAuthControllerLoginQueryError = unknown


export function useAdminAuthControllerLogin<TData = Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerLogin>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerLogin<TData = Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerLogin>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerLogin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerLogin<TData = Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 로그인 요청 및 인증코드 발송
 */

export function useAdminAuthControllerLogin<TData = Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerLogin>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerLoginQueryOptions(adminRequestCodeDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 로그인 인증코드 재발송
 */
export const adminAuthControllerResendCode = (
    adminRequestCodeDto: AdminRequestCodeDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminRequestCodeResponseDto>(
      {url: `/api/v1/admin/auth/resend-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminRequestCodeDto, signal
    },
      );
    }




export const getAdminAuthControllerResendCodeQueryKey = (adminRequestCodeDto?: AdminRequestCodeDto,) => {
    return [
    'POST', `/api/v1/admin/auth/resend-code`, adminRequestCodeDto
    ] as const;
    }


export const getAdminAuthControllerResendCodeQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError = unknown>(adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerResendCodeQueryKey(adminRequestCodeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerResendCode>>> = ({ signal }) => adminAuthControllerResendCode(adminRequestCodeDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerResendCodeQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerResendCode>>>
export type AdminAuthControllerResendCodeQueryError = unknown


export function useAdminAuthControllerResendCode<TData = Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerResendCode>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerResendCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerResendCode<TData = Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerResendCode>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerResendCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerResendCode<TData = Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 로그인 인증코드 재발송
 */

export function useAdminAuthControllerResendCode<TData = Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError = unknown>(
 adminRequestCodeDto: AdminRequestCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerResendCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerResendCodeQueryOptions(adminRequestCodeDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 이메일 찾기
 */
export const adminAuthControllerFindEmail = (
    adminFindEmailDto: AdminFindEmailDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminFindEmailResponseDto>(
      {url: `/api/v1/admin/auth/find-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminFindEmailDto, signal
    },
      );
    }




export const getAdminAuthControllerFindEmailQueryKey = (adminFindEmailDto?: AdminFindEmailDto,) => {
    return [
    'POST', `/api/v1/admin/auth/find-email`, adminFindEmailDto
    ] as const;
    }


export const getAdminAuthControllerFindEmailQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError = unknown>(adminFindEmailDto: AdminFindEmailDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerFindEmailQueryKey(adminFindEmailDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>> = ({ signal }) => adminAuthControllerFindEmail(adminFindEmailDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerFindEmailQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>>
export type AdminAuthControllerFindEmailQueryError = unknown


export function useAdminAuthControllerFindEmail<TData = Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError = unknown>(
 adminFindEmailDto: AdminFindEmailDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerFindEmail>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerFindEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerFindEmail<TData = Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError = unknown>(
 adminFindEmailDto: AdminFindEmailDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerFindEmail>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerFindEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerFindEmail<TData = Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError = unknown>(
 adminFindEmailDto: AdminFindEmailDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 이메일 찾기
 */

export function useAdminAuthControllerFindEmail<TData = Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError = unknown>(
 adminFindEmailDto: AdminFindEmailDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerFindEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerFindEmailQueryOptions(adminFindEmailDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 1회용 비밀번호 발급
 */
export const adminAuthControllerIssueTempPassword = (
    adminIssueTempPasswordDto: AdminIssueTempPasswordDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminIssueTempPasswordResponseDto>(
      {url: `/api/v1/admin/auth/issue-temp-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminIssueTempPasswordDto, signal
    },
      );
    }




export const getAdminAuthControllerIssueTempPasswordQueryKey = (adminIssueTempPasswordDto?: AdminIssueTempPasswordDto,) => {
    return [
    'POST', `/api/v1/admin/auth/issue-temp-password`, adminIssueTempPasswordDto
    ] as const;
    }


export const getAdminAuthControllerIssueTempPasswordQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError = unknown>(adminIssueTempPasswordDto: AdminIssueTempPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerIssueTempPasswordQueryKey(adminIssueTempPasswordDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>> = ({ signal }) => adminAuthControllerIssueTempPassword(adminIssueTempPasswordDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerIssueTempPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>>
export type AdminAuthControllerIssueTempPasswordQueryError = unknown


export function useAdminAuthControllerIssueTempPassword<TData = Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError = unknown>(
 adminIssueTempPasswordDto: AdminIssueTempPasswordDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerIssueTempPassword<TData = Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError = unknown>(
 adminIssueTempPasswordDto: AdminIssueTempPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerIssueTempPassword<TData = Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError = unknown>(
 adminIssueTempPasswordDto: AdminIssueTempPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 1회용 비밀번호 발급
 */

export function useAdminAuthControllerIssueTempPassword<TData = Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError = unknown>(
 adminIssueTempPasswordDto: AdminIssueTempPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerIssueTempPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerIssueTempPasswordQueryOptions(adminIssueTempPasswordDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 비밀번호 변경(180일)
 */
export const adminAuthControllerChangePassword = (
    adminChangePasswordDto: AdminChangePasswordDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminChangePasswordResponseDto>(
      {url: `/api/v1/admin/auth/password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: adminChangePasswordDto, signal
    },
      );
    }




export const getAdminAuthControllerChangePasswordQueryKey = (adminChangePasswordDto?: AdminChangePasswordDto,) => {
    return [
    'PATCH', `/api/v1/admin/auth/password`, adminChangePasswordDto
    ] as const;
    }


export const getAdminAuthControllerChangePasswordQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError = unknown>(adminChangePasswordDto: AdminChangePasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerChangePasswordQueryKey(adminChangePasswordDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>> = ({ signal }) => adminAuthControllerChangePassword(adminChangePasswordDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerChangePasswordQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>>
export type AdminAuthControllerChangePasswordQueryError = unknown


export function useAdminAuthControllerChangePassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError = unknown>(
 adminChangePasswordDto: AdminChangePasswordDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerChangePassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerChangePassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerChangePassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError = unknown>(
 adminChangePasswordDto: AdminChangePasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerChangePassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerChangePassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerChangePassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError = unknown>(
 adminChangePasswordDto: AdminChangePasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 비밀번호 변경(180일)
 */

export function useAdminAuthControllerChangePassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError = unknown>(
 adminChangePasswordDto: AdminChangePasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangePassword>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerChangePasswordQueryOptions(adminChangePasswordDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 최초/필수 비밀번호 변경
 */
export const adminAuthControllerChangeFirstPassword = (
    adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminChangePasswordResponseDto>(
      {url: `/api/v1/admin/auth/first-password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: adminChangeFirstPasswordDto, signal
    },
      );
    }




export const getAdminAuthControllerChangeFirstPasswordQueryKey = (adminChangeFirstPasswordDto?: AdminChangeFirstPasswordDto,) => {
    return [
    'PATCH', `/api/v1/admin/auth/first-password`, adminChangeFirstPasswordDto
    ] as const;
    }


export const getAdminAuthControllerChangeFirstPasswordQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError = unknown>(adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerChangeFirstPasswordQueryKey(adminChangeFirstPasswordDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>> = ({ signal }) => adminAuthControllerChangeFirstPassword(adminChangeFirstPasswordDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerChangeFirstPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>>
export type AdminAuthControllerChangeFirstPasswordQueryError = unknown


export function useAdminAuthControllerChangeFirstPassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError = unknown>(
 adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerChangeFirstPassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError = unknown>(
 adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerChangeFirstPassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError = unknown>(
 adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 최초/필수 비밀번호 변경
 */

export function useAdminAuthControllerChangeFirstPassword<TData = Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError = unknown>(
 adminChangeFirstPasswordDto: AdminChangeFirstPasswordDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerChangeFirstPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerChangeFirstPasswordQueryOptions(adminChangeFirstPasswordDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 로그인 인증코드 검증 및 토큰 발급
 */
export const adminAuthControllerVerifyCode = (
    adminVerifyCodeDto: AdminVerifyCodeDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminLoginResponseDto>(
      {url: `/api/v1/admin/auth/verify-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminVerifyCodeDto, signal
    },
      );
    }




export const getAdminAuthControllerVerifyCodeQueryKey = (adminVerifyCodeDto?: AdminVerifyCodeDto,) => {
    return [
    'POST', `/api/v1/admin/auth/verify-code`, adminVerifyCodeDto
    ] as const;
    }


export const getAdminAuthControllerVerifyCodeQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError = unknown>(adminVerifyCodeDto: AdminVerifyCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerVerifyCodeQueryKey(adminVerifyCodeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>> = ({ signal }) => adminAuthControllerVerifyCode(adminVerifyCodeDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerVerifyCodeQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>>
export type AdminAuthControllerVerifyCodeQueryError = unknown


export function useAdminAuthControllerVerifyCode<TData = Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError = unknown>(
 adminVerifyCodeDto: AdminVerifyCodeDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerVerifyCode<TData = Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError = unknown>(
 adminVerifyCodeDto: AdminVerifyCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerVerifyCode<TData = Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError = unknown>(
 adminVerifyCodeDto: AdminVerifyCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 로그인 인증코드 검증 및 토큰 발급
 */

export function useAdminAuthControllerVerifyCode<TData = Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError = unknown>(
 adminVerifyCodeDto: AdminVerifyCodeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerVerifyCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerVerifyCodeQueryOptions(adminVerifyCodeDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 관리자 액세스 토큰 재발급
 */
export const adminAuthControllerRefreshToken = (

 signal?: AbortSignal
) => {


      return axiosInstance<AdminLoginResponseDto>(
      {url: `/api/v1/admin/auth/refresh`, method: 'POST', signal
    },
      );
    }




export const getAdminAuthControllerRefreshTokenQueryKey = () => {
    return [
    'POST', `/api/v1/admin/auth/refresh`
    ] as const;
    }


export const getAdminAuthControllerRefreshTokenQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerRefreshTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>> = ({ signal }) => adminAuthControllerRefreshToken(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerRefreshTokenQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>>
export type AdminAuthControllerRefreshTokenQueryError = unknown


export function useAdminAuthControllerRefreshToken<TData = Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerRefreshToken<TData = Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerRefreshToken<TData = Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 관리자 액세스 토큰 재발급
 */

export function useAdminAuthControllerRefreshToken<TData = Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerRefreshToken>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerRefreshTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary 현재 관리자 정보 조회
 */
export const adminAuthControllerMe = (

 signal?: AbortSignal
) => {


      return axiosInstance<AdminMeResponseDto>(
      {url: `/api/v1/admin/auth/me`, method: 'GET', signal
    },
      );
    }




export const getAdminAuthControllerMeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerMe>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerMe>>, TError,void, TContext> => {

const mutationKey = ['adminAuthControllerMe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAuthControllerMe>>, void> = () => {


          return  adminAuthControllerMe()
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAuthControllerMeMutationResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerMe>>>

    export type AdminAuthControllerMeMutationError = unknown

    /**
 * @summary 현재 관리자 정보 조회
 */
export const useAdminAuthControllerMe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerMe>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAuthControllerMe>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminAuthControllerMeMutationOptions(options), queryClient);
    }
    /**
 * @summary 현재 관리자 프로필 상세 조회
 */
export const adminAuthControllerGetMyProfile = (

 signal?: AbortSignal
) => {


      return axiosInstance<AdminProfileResponseDto>(
      {url: `/api/v1/admin/auth/me/profile`, method: 'GET', signal
    },
      );
    }




export const getAdminAuthControllerGetMyProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>, TError,void, TContext> => {

const mutationKey = ['adminAuthControllerGetMyProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>, void> = () => {


          return  adminAuthControllerGetMyProfile()
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAuthControllerGetMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>>

    export type AdminAuthControllerGetMyProfileMutationError = unknown

    /**
 * @summary 현재 관리자 프로필 상세 조회
 */
export const useAdminAuthControllerGetMyProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAuthControllerGetMyProfile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminAuthControllerGetMyProfileMutationOptions(options), queryClient);
    }
    /**
 * @summary 현재 관리자 프로필 수정
 */
export const adminAuthControllerUpdateMyProfile = (
    updateAdminProfileDto: UpdateAdminProfileDto,
 signal?: AbortSignal
) => {


      return axiosInstance<AdminProfileResponseDto>(
      {url: `/api/v1/admin/auth/me/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminProfileDto, signal
    },
      );
    }




export const getAdminAuthControllerUpdateMyProfileQueryKey = (updateAdminProfileDto?: UpdateAdminProfileDto,) => {
    return [
    'PATCH', `/api/v1/admin/auth/me/profile`, updateAdminProfileDto
    ] as const;
    }


export const getAdminAuthControllerUpdateMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError = unknown>(updateAdminProfileDto: UpdateAdminProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAuthControllerUpdateMyProfileQueryKey(updateAdminProfileDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>> = ({ signal }) => adminAuthControllerUpdateMyProfile(updateAdminProfileDto, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAuthControllerUpdateMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>>
export type AdminAuthControllerUpdateMyProfileQueryError = unknown


export function useAdminAuthControllerUpdateMyProfile<TData = Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError = unknown>(
 updateAdminProfileDto: UpdateAdminProfileDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerUpdateMyProfile<TData = Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError = unknown>(
 updateAdminProfileDto: UpdateAdminProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>,
          TError,
          Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAuthControllerUpdateMyProfile<TData = Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError = unknown>(
 updateAdminProfileDto: UpdateAdminProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 현재 관리자 프로필 수정
 */

export function useAdminAuthControllerUpdateMyProfile<TData = Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError = unknown>(
 updateAdminProfileDto: UpdateAdminProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAuthControllerUpdateMyProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAuthControllerUpdateMyProfileQueryOptions(updateAdminProfileDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






